import { z } from 'zod';

// 「設定なし」モードのスキーマ
const noneSchema = z.object({
  mode: z.literal('none'),
  fee_rate: z.string().optional(),
  fee_amount: z.string().optional(),
  note: z.string().max(500, '備考は500文字以内で入力してください').optional(),
  disabled: z.boolean(),
});

// 「成約手数料率」モードのスキーマ
const rateSchema = z.object({
  mode: z.literal('rate'),
  fee_rate: z
    .string()
    .min(1, '成約手数料率を入力してください')
    .refine((v) => {
      const n = parseFloat(v);
      return Number.isFinite(n);
    }, '成約手数料率を入力してください')
    .refine((v) => {
      const n = parseFloat(v);
      return n >= 0.1 && n <= 100.0;
    }, '成約手数料率は0.1〜100.0の範囲で入力してください'),
  fee_amount: z.string().optional(),
  note: z.string().max(500, '備考は500文字以内で入力してください').optional(),
  disabled: z.boolean(),
});

// 「成約金額」モードのスキーマ
const amountSchema = z.object({
  mode: z.literal('amount'),
  fee_rate: z.string().optional(),
  fee_amount: z
    .string()
    .min(1, '成約手数料額を入力してください')
    .refine((v) => {
      // parseInt は小数点を切り捨てるため Number で変換して整数チェックを行う
      const n = Number(v);
      return Number.isFinite(n) && Number.isInteger(n);
    }, '成約手数料額は整数で入力してください')
    .refine((v) => {
      const n = Number(v);
      return n >= 1 && n <= 99999;
    }, '成約手数料額は1〜99,999万円の範囲で入力してください'),
  note: z.string().max(500, '備考は500文字以内で入力してください').optional(),
  disabled: z.boolean(),
});

// discriminated union でモード別バリデーションをまとめる
export const allianceFeeSchema = z.discriminatedUnion('mode', [
  noneSchema,
  rateSchema,
  amountSchema,
]);

export type AllianceFeeFormValues = z.infer<typeof allianceFeeSchema>;
